import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { getNewsByIds } from "../../server/apihelper"; // ✅ new optimized API call
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export const ExperienceMcgans = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ IDs you want to display
  const targetIds = [1, 2, 3, 127, 85, 82, 83, 7, 8, 9, 10, 11, 187, 200, 12, 13, 14, 15, 16];

  useEffect(() => {
    AOS.init();
    const fetchNews = async () => {
      try {
        const res = await getNewsByIds(targetIds);
        if (res?.status && res?.data) {
          // ✅ Sort by date (latest first)
          const sorted = res.data.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          setNewsList(sorted);
        }
      } catch (error) {
        console.error("❌ Error fetching news by IDs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const options = {
    loop: true,
    margin: 30,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 800,
    navText: [
      "<i class='ri-arrow-left-s-line'></i>",
      "<i class='ri-arrow-right-s-line'></i>",
    ],
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      992: { items: 3 },
    },
  };

  return (
    <>
      <Helmet>
        <title>Experience At McGAN’S | News & Events</title>
        <meta
          name="description"
          content="Stay updated with the latest news, stories, and events from McGAN’S Ooty School of Architecture."
        />
      </Helmet>

      <div className="experience-mcgans-section ptb-100">
        <div className="container">
          <div className="section-title text-center">
            <h2 className="section-heading">Experience At McGAN’S</h2>
            <p className="section-subtitle">
              Explore the latest stories, news, and happenings from our campus.
            </p>
          </div>

          {loading ? (
            <p className="text-center">Loading news...</p>
          ) : newsList.length > 0 ? (
            <OwlCarousel
              className="experience-carousel owl-theme"
              {...options}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {newsList.map((item, index) => (
                <div className="experience-card" key={index}>
                  <div className="experience-image">
                    <Link to={`/news-details/${item.primaryId}`} className="experience-title">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="img-fluid"
                        width={420}
                        height={280}
                      />
                      <h3>{item.title}</h3>
                    </Link>

                    <p className="experience-desc">
                      {item.description
                        ? item.description.split(" ").slice(0, 15).join(" ")
                        : ""}{" "}
                      ...
                    </p>

                    <Link
                      to={`/news-details/${item.primaryId}`}
                      className="read-more-link"
                    >
                      Read More <i className="flaticon-next"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          ) : (
            <p className="text-center">No news found.</p>
          )}

          <div className="experience-more-btn text-center mt-4">
            <Link to="/news" className="default-btn">
              More At McGAN’S <i className="flaticon-next"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
